import { _calculate_duration, _calculate_duration_in_ms } from '../../../helpers/utilities';
import { relaysXT1Control } from './virtual_temp_scheme_helpers';

const OFF = {
	r: '',
	set: 'off',
	persist: true,
	asneeded: 1,
};

const ON = {
	r: '',
	set: 'on',
	persist: true,
	asneeded: 1,
};

/**
 * action  structure 
heat
 tocool: {blk: [{r: "dev:3326185:r1", set: "off", persist: true, asneeded: 1}]}
 toheat: {blk: [{r: "dev:3326185:r1", set: "on", persist: true, asneeded: 1]}


 cool
 "tocool":{ "blk":[ { "r":"dev:246943549551629:r2", "set":"on", "persist":true , "asneeded": 1}] },
  "toheat":{ "blk":[{ "r":"dev:246943549551629:r2", "set":"off", "persist":true, "asneeded":1 }]
  }, 
 * 
*/

//helper function for controls
const prepare_relays_control = (data: {
	selectedItems: string[] | [];
	type: 'heat' | 'cool';
	default_output: 'normal' | 'normal_closed';
}) => {
	//default output will reverse the logic
	// for heat only for now
	const { default_output } = data;
	let tocool = { blk: [] },
		toheat = { blk: [] };

	console.log('default output ', default_output);

	for (const device of data.selectedItems) {
		let [devId = '', channel = '0'] = (device as any).id.split('_');
		let hexToDecimal = devId.startsWith('X') ? devId : parseInt(devId, 16);
		let r = `dev:${hexToDecimal}:r${Number(channel) + 1}`;
		let off = { ...OFF, r: r };
		let on = { ...ON, r: r };
		const xt1Component = relaysXT1Control(devId);
		if (xt1Component) {
			on = xt1Component.on;
			off = xt1Component.off;
		}
		tocool.blk.push(data.type === 'heat' ? (default_output === 'normal' ? off : on) : on);
		toheat.blk.push(data.type === 'heat' ? (default_output === 'normal' ? on : off) : off);
	}
	console.log(toheat, tocool);
	return { tocool, toheat };
};

//Use to create toheat and tocool on device selction
export const create_control = (obj) => {
	switch (obj.control.type) {
		case 'relay':
			return prepare_relays_control(obj.data);
		case 'ac':
			return undefined;
		default:
			return undefined;
	}
};

//create temp sensor in scene service format
export const create_temperature_sensor = (tmp) => {
	if (tmp?.is_virtual_temp) {
		return {
			tschem: {
				r: `dev:${tmp.id}:number${Number(tmp.ext_sen_id) + 1}`,
			},
		};
	} else if (!tmp.is_ext_temp) {
		//here must have a check for external sensors
		return {
			tschem: {
				r: `dev:${tmp.id.startsWith('X') ? tmp.id : parseInt(tmp.id, 16)}:tmp`,
			},
		};
	}
	let temp = !isNaN(Number(tmp.ext_sen_id)) ? Number(tmp.ext_sen_id) + 1 : 0;
	let tmp_id = tmp.id.split('|')[0];
	return {
		tschem: {
			r: `dev:${tmp_id.startsWith('X') ? tmp_id : parseInt(tmp_id, 16)}:t${temp}`,
		},
	};
};
